import { each } from 'lodash'
import { app, menu, search, modal } from '../../utils/store'
import { activate, deactivate } from '../../utils/states'
import { media } from '../../utils/media'
import { injectScript } from '../../utils/dom'

export default class Modal {
    constructor() {
        this.urlParameters = new URLSearchParams(window.location.search);

        this.main = {
            toggler: document.getElementById('menu-toggler'),
            logo: document.getElementById('logo'),
        }
        this.menu = {
            toggler: document.getElementById('menu-toggler'),
            main: document.getElementById('main-menu')
        };

        this.search = {
            input: document.getElementById('global-search'),
            toggler: document.getElementById('search-toggler'),
        }
        
        this.modal = {
            el: document.querySelectorAll('[data-modal]'),
            toggler: document.querySelectorAll('.btn-modal'),
            close_modal: document.getElementById('close-modal'),
        }

        this.configurator = {
            init: false,
            active: this.urlParameters.get('configurator'),
            container:  document.querySelector('[data-configurator-async]'),
        }

        this.body = document.body;

        this.toggle();

        if(this.configurator.active){
            modal.current = document.querySelector('[id="configurator-modal"]')
            modal.isOpen = true
            if(!this.configurator.init){
                this.create3Dviewer()
            }
        }
    }

    toggle(){
        each(this.modal.toggler,(toggler) => {
            toggler.addEventListener('click', (event) => {
                var data_modal = event.target.getAttribute('data-target')
                
                event.preventDefault()

                modal.isOpen = true
                modal.current = document.querySelector('[id="' + data_modal + '"]')

                activate(this.main.toggler)
                activate(modal.current)
                activate(this.search.toggler)
                deactivate(app.header)
                deactivate(document.getElementById('login-reserved'))
                deactivate(document.querySelector('[data-menu-products]'))
                deactivate(document.querySelector('[data-menu-actions]'))
                document.body.classList.add('overflow-hidden')
                document.body.classList.add('modal-active')

                // If Modal 'Video'
                if(modal.current.hasAttribute('data-modal-video')){
                    modal.current.querySelector('video').play()
                }

                // If Modal 'Configurator'
                if(modal.current.hasAttribute('data-modal-configurator')){
                    app.header.classList.add('inverted')
                    menu.current = undefined
                    menu.isOpen = false
                    deactivate(document.getElementById('main-menu'))

                    if(!this.configurator.init){
                        this.create3Dviewer()
                    }
                }

                // If Modal 'Form'
                if(media('<iPadLandscape') && (modal.current.hasAttribute('data-modal-form') || modal.current.hasAttribute('data-modal-advertising'))){
                    app.header.classList.add('inverted')
                }
            });
        });
        
        this.menu.toggler.addEventListener('click', (event) => {
            if( modal.isOpen ){
                deactivate(modal.current)
                deactivate(this.main.toggler)
                deactivate(this.search.toggler)
                activate(app.header)
                activate(document.getElementById('login-reserved'))
                activate(document.querySelector('[data-menu-products]'))
                activate(document.querySelector('[data-menu-actions]'))

                document.body.classList.remove('overflow-hidden')
                document.body.classList.remove('modal-active')
                
                // If Modal 'Video'
                if(modal.current.hasAttribute('data-modal-video')){
                    modal.current.querySelector('video').pause()
                    modal.current.querySelector('video').currentTime = 0
                }

                // If Modal 'Configurator'
                if(modal.current.hasAttribute('data-modal-configurator')){
                    app.header.classList.remove('inverted')
                    app.header.classList.remove('reverted')
                }

                // If Modal 'Form'
                if(media('<iPadLandscape') && (modal.current.hasAttribute('data-modal-form') || modal.current.hasAttribute('data-modal-advertising'))){
                    app.header.classList.remove('inverted')
                }

                modal.current = undefined
                modal.isOpen = false
            }
        });
    }

    create3Dviewer = () => {
        let configurator = document.createElement('div')
        let loading = document.createElement('div')
        let selector = document.createElement('p')

        this.configurator.container.append(configurator)

        configurator.id = 'modelviewer3d-container'
        loading.id = 'modelviewer3d-loading'
        selector.id = 'modelviewer3d-ui-selector'

        configurator.append(loading)

        configurator.width = 1400
        configurator.height = 600
        configurator.setAttribute('width', configurator.width)
        configurator.setAttribute('height', configurator.height)
        configurator.setAttribute('data-root','https://bontempi.azurewebsites.net/')
        configurator.setAttribute('data-background-color','0xffffff')
        configurator.setAttribute('data-language',app.language)
        if(app.page == 'single-product'){
            configurator.setAttribute('data-id',app.sku)
        }
        configurator.setAttribute('data-country','it')

        selector.width = 1400

        configurator.parentNode.append(selector)

        this.initModel3D(configurator)
    }

    initModel3D = async (appendTo) => {
        await injectScript('https://bontempi.azurewebsites.net/viewer/js/three.min.js',appendTo)
        await injectScript('https://bontempi.azurewebsites.net/viewer/js/loaders/OBJLoader.js',appendTo)
        await injectScript('https://bontempi.azurewebsites.net/viewer/js/controls/OrbitControls.js',appendTo)
        await injectScript('https://bontempi.azurewebsites.net/viewer/js/modelviewer/modelviewer.min.js',appendTo)
        await this.ModelViewer3d()

        this.configurator.init = true
    }

    ModelViewer3d = () => {
        const DEFAULT_CONFIGURATION = "bontempi",
            version = "0.9.0",
            REDIRECT_DATAROOT = {
                "https://bontempi.azurewebsites.net/": "https://bontempistorage.z6.web.core.windows.net/",
                "https://bontempihk.azurewebsites.net/": "https://bontempihkstorage.z7.web.core.windows.net/"
            },
            CONFIGURATIONS = {
                "https://bontempi.azurewebsites.net/": "bontempi",
                "https://bontempihk.azurewebsites.net/": "bontempihk"
            };
    
        function getUrlParameter(name, url) {
            url || (url = window.location.href), name = name.replace(/[\[\]]/g, "\\$&");
            var regex, results = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)").exec(url);
            return results ? results[2] ? decodeURIComponent(results[2].replace(/\+/g, " ")) : "" : null
        }
    
        function getParameter(container, param, urlParam) {
            let result = urlParam ? getUrlParameter(urlParam) : null;
            return !result && container && container.hasAttribute(param) && (result = container.getAttribute(param)), result
        }
    
        function addScript(url, waitForCompletion) {
            return new Promise((function(resolve, reject) {
                var script = document.createElement("script");
                script.type = "text/javascript",
                script.src = url, 
                script.async = !0, 
                waitForCompletion && (script.onload = function() {
                    resolve(url)
                }, script.onerror = function(error) {
                    reject(url + " failed to load: " + error)
                }), document.querySelector("head").appendChild(script), waitForCompletion || resolve(url)
            }))
        }
    
        function addWebComponent(configuration, dataRoot) {
            if (container) {
                let language = getParameter(container, "data-language", "lang"),
                    country = getParameter(container, "data-country"),
                    modelId = getParameter(container, "data-id", "id");
                modelId || (modelId = getParameter(container, "data-model-id", "model"));
                let familyId = getParameter(container, "data-family-definition", "family"),
                    pricelist = getParameter(container, "pricelist"),
                    clearColor = getParameter(container, "data-background-color"),
                    viewerWidth = getParameter(container, "width") || 0,
                    viewerHeight = getParameter(container, "height"),
                    browserWidth = getParameter(browserContainer, "width") || 0,
                    uiWidth = getParameter(uiContainer, "width") || 0,
                    wcNode = document.createElement("ubisive-configuratore");
                wcNode.id = "configuratore", wcNode.setAttribute("configuration", configuration), language && wcNode.setAttribute("language", language), country && wcNode.setAttribute("country", country), dataRoot && wcNode.setAttribute("data-root", dataRoot), familyId && wcNode.setAttribute("family-id", familyId), modelId && wcNode.setAttribute("model-id", modelId), browserContainer && !modelId && wcNode.setAttribute("show-browser", !0), pricelist && wcNode.setAttribute("pricelist", pricelist), clearColor && wcNode.setAttribute("clear-color", clearColor), uiWidth && wcNode.setAttribute("requested-width", uiWidth), browserWidth && wcNode.setAttribute("requested-browser-width", browserWidth), viewerWidth && wcNode.setAttribute("requested-viewer-width", viewerWidth);
                let maxWidth = Math.max(viewerWidth, browserWidth, uiWidth);
                maxWidth > 0 && (wcNode.style.width = maxWidth + "px"), container.appendChild(wcNode)
            }
        }
    
        function addVersionToUrl(originalUrl, versionNumber) {
            return null == originalUrl ? null : (null != versionNumber && null != versionNumber || (versionNumber = filesVersion), originalUrl.indexOf("?") >= 0 ? originalUrl + "&ver=" + versionNumber : originalUrl + "?ver=" + versionNumber)
        }

        var container, browserContainer, uiContainer, dataRoot;
    
        function injectNewConfigurator() {
            console.log('Inject Configurator')

            if (!(container = document.getElementById("modelviewer3d-container"))){
                return void console.error("modelviewer3d-container element not found");
            } 

            browserContainer = document.getElementById("modelviewer3d-browser"), 
            uiContainer = document.getElementById("modelviewer3d-ui-selector"), 
            dataRoot = getParameter(container, "data-root");

            let configuration = "bontempi";

            CONFIGURATIONS && CONFIGURATIONS[dataRoot] && (configuration = CONFIGURATIONS[dataRoot]), 
            REDIRECT_DATAROOT && REDIRECT_DATAROOT[dataRoot] && (dataRoot = REDIRECT_DATAROOT[dataRoot]);

            let webComponentUrl = `${dataRoot}js/dist/ubisive-configuratore.min.js`;

            webComponentUrl = addVersionToUrl(webComponentUrl, "0.9.0"), addScript(webComponentUrl, !0).then(url => {
                console.debug(`Script Loaded: ${url}`), addWebComponent(configuration, dataRoot)
            }).catch(err => {
                console.error(err)
            })
        }

        injectNewConfigurator()
    }
}